import axios from 'axios';
import React, { useEffect, useState } from 'react'

import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import EditNoteIcon from '@mui/icons-material/EditNote';
import MenuIcon from '@mui/icons-material/Menu';
import { v4 as UUIDV4 } from 'uuid';
import CustomSpinner from "../components/CustomSpinner"
import dayjs from "dayjs"

function AutomationMonitor({ serverURL, user, setUser, setShowSideOverlay }) {
    const [allAutomations, setAllAutomations] = useState([])
    const [totalAutomations, setTotalAutomations] = useState(0)
    const [showAddAutomationModel, setShowAddAutomationModel] = useState(false)


    const [automationNameState, setAutomationNameState] = useState("")
    const [statusState, setStatusState] = useState("inactive")
    const [lastRunState, setLastRunState] = useState(dayjs().$d)
    const [nexRunState, setNexRunState] = useState(dayjs().add(1, "days").$d)

    const [askToDelete, setAskToDelete] = useState(false)

    const [automationToUse, setAutomationToUse] = useState(null)

    const [loading, setLoading] = useState(true)

    const getAllAutomations = async () => {
        const getNow = await axios.post(serverURL + "/automationMonitor/getAllAutomations")
        if (getNow.status === 200) {
            setTotalAutomations(getNow.data.total)

            if (getNow.data.automations) {

                getNow.data.automations.map(async (auto, key) => {
                    if (dayjs(auto.lastRunTime).valueOf() < dayjs().subtract(1, "minutes").valueOf()) {
                        const query = {
                            "automationId": auto.automationId,
                            "automationName": auto.automationName,
                            "status": "Inactive",
                            "lastRunTime": auto.lastRunTime,
                            "nextRunTime": auto.nextRunTime,
                        }
                        const updateStatus = await axios.post(serverURL + "/automationMonitor/updateAutomation", query)
                        if (updateStatus.status === 200) {
                            // console.log(updateStatus.data)
                        } else {
                            console.log(updateStatus.data)
                        }
                    } else {

                    }
                })
                setAllAutomations(getNow.data.automations)
            } else {
                setAllAutomations([])
            }
            setLoading(false)
        } else {
            console.log(getNow.data)
            setLoading(false)
        }
    }

    const saveAutomation = async (e) => {
        e.preventDefault()
        const query = {
            "automationName": automationNameState,
            "status": statusState,
            "lastRunTime": lastRunState,
            "nextRunTime": nexRunState,
            "logs": [`Log Generated at ${dayjs().format("D MMM YYYY, h:mm:ssa")}`]
        }
        const saveAutomationNow = await axios.post(serverURL + "/automationMonitor/createAutomation", query)

        if (saveAutomationNow.status === 200) {
            setAllAutomations([...allAutomations, saveAutomationNow.data])
            setTotalAutomations(totalAutomations + 1)
            setShowAddAutomationModel(false);
        } else {
            console.log(saveAutomationNow.data)
        }
    }

    const deleteAutomation = async (id) => {
        const deleteNow = await axios.post(serverURL + "/automationMonitor/deleteAutomation", { "automationId": id })
        if (deleteNow.status === 200) {
            setAllAutomations(allAutomations.filter((automation) => { return automation.automationId !== id }))
            setAutomationToUse(null)
            setAskToDelete(false)
        } else {
            console.log(deleteNow.data)
        }
    }

    useEffect(() => {
        setInterval(() => {
            getAllAutomations()
        }, 1000)
    }, [])
    return (
        <>
            <div className="transback h-100 overflow-auto p-3 d-flex flex-column">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between">
                    <span>Automation Monitor</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='my-3'>
                    <button className='btn btn-sm btn-outline-dark rounded-pill px-3' onClick={(e) => { setShowAddAutomationModel(true) }}>
                        <i className='fa fa-add'></i> Add
                    </button>
                </div>
                <div className='w-100 h-100 overflow-auto'>
                    {
                        loading ?
                            <div className='w-100 h-100 d-flex align-items-center justify-content-center'>
                                <CustomSpinner size={1} />
                            </div>
                            :
                            allAutomations?.length > 0 ?
                                <table className='table table-yesgermany table-hover table-bordered table-striped'>
                                    <thead>
                                        <tr align="center">
                                            <th>#{totalAutomations}</th>
                                            {/* <th>Id</th> */}
                                            <th>Name</th>
                                            <th>Status</th>
                                            <th>Progress</th>
                                            <th>Start Time</th>
                                            <th>Last Run Time</th>
                                            <th>Next Run Time</th>
                                            <th>Logs</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            allAutomations.map((automation, key) => {
                                                return (
                                                    <tr key={key} align="center">
                                                        <td>{key + 1}</td>
                                                        {/* <td>{automation.automationId}</td> */}
                                                        <td className='text-capitalize'>{automation.automationName}</td>
                                                        <td className='text-capitalize'>{automation.status}</td>
                                                        <td className={`text-capitalize fw-bold ${automation.status === "active" ? "text-success" : "text-danger"}`}>{automation.progress?.current} / {automation.progress?.total}</td>
                                                        <td>{dayjs(automation.startTime).isValid() ? dayjs(automation.startTime).format("D MMM YYYY, h:mm:ssa") : "-"}</td>
                                                        <td>{dayjs(automation.lastRunTime).format("D MMM YYYY, h:mm:ssa")}</td>
                                                        <td>{dayjs(automation.nextRunTime).format("D MMM YYYY, h:mm:ssa")}</td>
                                                        <td>{automation.logs.map((log, key) => { return <button key={key} className='btn btn-sm p-1 btn-dark'>{log}</button> })}</td>
                                                        <td>
                                                            <button className='btn btn-md p-0' title={`Delete ${automation.automationName} Automation?`} onClick={() => { setAskToDelete(true); setAutomationToUse(automation); }}>
                                                                <i className='fa fa-trash text-danger'></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                                :
                                <div className='alert alert-secondary text-center fw-bold'>No Automations Available</div>
                    }
                </div>
            </div>

            <Modal
                show={askToDelete}
                centered
                onHide={() => { setAskToDelete(false); }}>
                <form onSubmit={(e) => { saveAutomation(e) }}>
                    <Modal.Header closeButton closeVariant='black'>
                        <Modal.Title style={{ fontSize: "1.3rem" }}>Delete Automation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='p-0 m-0'>
                        <div className="alert alert-danger text-center rounded-0 m-0">
                            Do you want to delete <b className='text-capitalize'>{automationToUse?.automationName}</b> Automation?
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex align-items-center justify-content-end d-flex gap-3">
                            <button type='button' className='btn btn-sm btn-outline-dark rounded-pill w-100' style={{ maxWidth: "80px" }}>No</button>
                            <button type='submit' className='btn btn-sm btn-success rounded-pill w-100' style={{ maxWidth: "80px" }} onClick={(e) => { deleteAutomation(automationToUse.automationId) }}>Yes</button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal
                show={showAddAutomationModel}
                centered
                onHide={() => { setShowAddAutomationModel(false); }}>
                <form onSubmit={(e) => { saveAutomation(e) }}>
                    <Modal.Header closeButton closeVariant='black'>
                        <Modal.Title>Add Automation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <input type="text" placeholder='Automation Name' className='form-control' onChange={(e) => { setAutomationNameState(e.target.value) }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex align-items-center justify-content-end d-flex gap-3">
                            <button type='button' className='btn btn-sm btn-outline-dark rounded-pill w-100' style={{ maxWidth: "80px" }}>Cancel</button>
                            <button type='submit' className='btn btn-sm btn-success rounded-pill w-100' style={{ maxWidth: "80px" }}>Save</button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default AutomationMonitor